import { useDialog } from "primevue/usedialog";
import { defineAsyncComponent } from "vue";




const useSuperAdmin = () => {

  const dialog = useDialog();


  const showCompanySelectionModal = () => {
    const dialogRef = dialog.open(
      //@ts-ignore
      defineAsyncComponent(() => import('./CompanySelection.vue')),
      {
        props: {
          header: 'Please Select Company',
          style: {
            width: '30vw',
            minWidth: '30vw'
          },
        }
      }
    )
  }

  return {
    showCompanySelectionModal,
  }
}

export default useSuperAdmin;